import React from 'react';
import { Lightbulb } from 'lucide-react';

const Logo = ({ className = "", size = "small" }) => {
  // Config for different sizes
  const sizes = {
    small: "w-8 h-8",      // For Navbar
    large: "w-16 h-16",    // For Login Screen
    hero: "w-24 h-24"      // For "Day Zero" Empty State
  };

  // Determine text color based on className or size
  const textColorClass = className.includes('text-white') 
    ? 'text-white' 
    : size === 'small' 
      ? 'text-white'  // Navbar always uses white text
      : 'text-slate-900 dark:text-white';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* The Icon Container with Glow Effect */}
      <div className={`relative flex items-center justify-center rounded-xl bg-gradient-to-br from-indigo-600 to-violet-600 shadow-lg shadow-indigo-500/30 text-white ${sizes[size]} p-2`}>
        <Lightbulb className="w-full h-full stroke-[1.5]" />
        
        {/* Optional: Inner "Spark" Pulse for animation */}
        <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-white/20"></div>
      </div>

      {/* The Text (Only show if needed, or handle externally) */}
      {size !== 'hero' && (
        <span className={`font-bold tracking-tight ${size === 'large' ? 'text-4xl' : 'text-xl'} ${textColorClass}`}>
          EPIPHORIC
        </span>
      )}
    </div>
  );
};

export default Logo;

